export enum EMaoMaintenanceBadge {
  'CLN' = 'CLN',
  'AOG' = 'AOG',
  'SCMX' = 'SCMX',
  'LMX' = 'LMX',
  'MEL' = 'MEL',
  'SerC' = 'SerC',
}
